<template>
  <div class="gc-status-chip">
    <label
      v-bind:class="{
        active: status == 'Active',

        inactive: status == 'Inactive',
      }"
      >{{ status }}</label
    >
  </div>
</template>

<script>
export default {
  props: {
    status,
  },
};
</script>

<style lang="scss" scoped>
.gc-status-chip label {
  padding: 1px 5px;
  min-width: 76px;
}
label {
  display: block;
  color: white;
  background: #e2e2e2;
  border-radius: 8.5px;
  padding: 1px 5px;
  height: 17px !important;
  font-size: 11px;
  line-height: 1.5 !important;
  text-align: center;
}

.active {
  background: #62d26f;
}

.inactive {
  background-color: #e8384f;
}
</style>
